import { useState, FunctionComponent, KeyboardEventHandler } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { Tooltip } from 'dibs-elements/exports/Tooltip';
import { LocalizedImage } from 'dibs-elements/exports/LocalizedImage';
import HoverableQuestionMarkIcon from './HoverableQuestionMarkIcon';
import styles from '../../styles/ACHForm.scss';

type Props = {
    visible?: boolean;
};

const messages = defineMessages({
    alt: {
        id: 'RoutingNumberTooltip.imageAltAttribute',
        defaultMessage: 'Routing Number',
    },
});

const RoutingNumberTooltip: FunctionComponent<Props> = ({ visible = false }) => {
    const intl = useIntl();
    const [isVisible, setIsVisible] = useState(visible);

    const toggleTooltip = (): void => setIsVisible(!isVisible);

    const handleKeyPress: KeyboardEventHandler<HTMLDivElement> = event => {
        if (event.key === 'Enter') {
            toggleTooltip();
        }
    };

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={toggleTooltip}
            onKeyPress={handleKeyPress}
            className={styles.tooltip}
        >
            <HoverableQuestionMarkIcon className={styles.tooltipIcon} />
            <Tooltip type="coachmark" isVisible={isVisible} closeOnOutsideClick direction="bottom">
                <div className={styles.tooltipImageWrapper}>
                    <LocalizedImage
                        className={styles.tooltipImage}
                        src="https://a.1stdibscdn.com/dist/adhoc/payment-methods/check-tooltip.png"
                        alt={intl.formatMessage(messages.alt)}
                    />
                </div>
            </Tooltip>
        </div>
    );
};

export default RoutingNumberTooltip;
